import Cookies, { CookieSetOptions } from 'universal-cookie';

import { IUserLogged } from "../interfaces";
import { Roles } from '../contants';

const application = 'Enerzee';

const createKey = (value: string) => (btoa(`${application}${value}`)).replace('=', '').replace('=', '');

const getCookieDomain = () => {
    const host = window.location.hostname;
    if (host.includes("enerzee.com.br") || host.includes("enerzee.com") || host.includes("azurewebsites.net")){
         return host;
    }
    return undefined; // localhost ou outros: não define domain
};

const keys = {
    tokenName: createKey(`Token`),
    refreshTokenName: createKey(`RefreshToken`),
    userLogged: createKey(`userLogged`),
    login: createKey(`Login`),
    language: createKey(`Language`),
    loginBySwit: createKey(`LoginBySwit`)
}

const defaultCookieOptions: CookieSetOptions = {
    path: '/',
    domain: getCookieDomain(),
    sameSite: 'strict'
};

const cookies = new Cookies();

class StorageService {

    public setLogin(value: any) {
        if (value === null)
            localStorage.removeItem(keys.login);
        else
            localStorage.setItem(keys.login, JSON.stringify(value));
    }

    public getLogin() {
        const value = localStorage.getItem(keys.login);
        if (value === null || value === undefined)
            return null;
        return JSON.parse(value);
    }

    public setToken(token: string) {
        cookies.set(keys.tokenName, btoa(JSON.stringify({ token: token })), defaultCookieOptions);
    }

    public setRefreshToken(token: string) {
        cookies.set(keys.refreshTokenName, btoa(JSON.stringify({ token: token })), defaultCookieOptions);
    }

    public getToken(): string | null {
        let token = cookies.get(keys.tokenName);
        if (token === null || token === undefined)
            return null;
        return JSON.parse(atob(token)).token;
    }

    public getRefreshToken(): string | null {
        let token = cookies.get(keys.refreshTokenName);
        if (token === null || token === undefined)
            return null;
        return JSON.parse(atob(token)).token;
    }

    public setUserLogged(user: IUserLogged) {
        cookies.set(keys.userLogged, btoa(JSON.stringify(user)), defaultCookieOptions);
    }

    public getUserLogged(): Promise<IUserLogged> {
        return new Promise((resolve, reject) => {
            try {
                let user = cookies.get(keys.userLogged);
                if (user === null || user === undefined) {
                    resolve(null as any);
                } else {
                    resolve(JSON.parse(atob(user)));
                }
            } catch (error) {
                reject(error);
            }
        });
    }

    public updateTwoFactorEnabledUserLogged(): Promise<void> {
        return new Promise((resolve, reject) => {
            try {
                this.getUserLogged().then(user => {
                    user.twoFactorEnabled = !user.twoFactorEnabled;
                    this.setUserLogged(user);
                    resolve();
                }).catch(error => {
                    reject(error);
                });
            } catch (error) {
                reject(error);
            }
        });
    }

    public updateAvatarUserLogged(avatar: string): Promise<void> {
        return new Promise((resolve, reject) => {
            try {
                this.getUserLogged().then(user => {
                    user.avatar = avatar;
                    this.setUserLogged(user);
                    resolve();
                }).catch(error => {
                    reject(error);
                });
            } catch (error) {
                reject(error);
            }
        });
    }

    public getUserRoles(): Promise<Roles[]> {
        return new Promise((resolve, reject) => {
            try {
                this.getUserLogged().then(user => {
                    resolve(user?.roles);
                }).catch(error => {
                    reject(error);
                });
            } catch (error) {
                reject(error);
            }
        });
    }


    public setLanguage(key: string) {
        localStorage.setItem(keys.language, key);
    }

    public getLanguage() {
        return localStorage.getItem(keys.language);
    }

    public logOut() {
        cookies.remove(keys.userLogged, defaultCookieOptions);
        cookies.remove(keys.tokenName, defaultCookieOptions);
        cookies.remove(keys.refreshTokenName, defaultCookieOptions);
        localStorage.removeItem(keys.login)
        sessionStorage.clear();
    }

    public logOutForLogin() {
        this.logOut();
        window.location.href = "/login";
    }

    public setRefreshingToken(status: boolean) {
        localStorage.setItem("onRefreshingToken", status.toString());
    }

    public getRefreshingToken() {
        const storage = localStorage.getItem("onRefreshingToken");
        if (storage) {
            return localStorage.getItem("onRefreshingToken") === "true";
        } else {
            localStorage.setItem("onRefreshingToken", "false");
            return false;
        }
    }
    public setLoginBySwit(value: any) {
        if (value === null)
            localStorage.removeItem(keys.loginBySwit);
        else
            localStorage.setItem(keys.loginBySwit, value);
    }
    public getLoginBySwit() {
        const storage = localStorage.getItem(keys.loginBySwit);
        return storage;
    }

}
const storageService = new StorageService();

export default storageService;
